import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/other/apply/save',
    data: form,
    method: 'post'
  })